import {MineMenu} from "@/api/menu";

function importComponent(comp) {
    console.log("importComponent/", comp)
    if (comp === "") {
        return
    }
    if (comp === "@/layouts/DefaultLayout") {
        return  () => import("@/layouts/DefaultLayout")
    } else {
        return () => import(`@/views/${comp}`)
    }
}

export async function getMenus() {
  let data = await MineMenu()
  return data.data.data
}

export function addDynamicRoutes(router, menus, parent_menu) {
    for (let menu of menus) {
        if (menu.component) {
            let route = {
                path: menu.path,
                icon: menu.icon,
                icon_type: menu.icon_type,
                name: menu.menu_name,
                visible: menu.visible,
                component: importComponent(menu.component)
            }
            if (parent_menu !== undefined && parent_menu !== null) {
                router.addRoute(parent_menu.menu_name, route)
            } else {
                router.addRoute(route)
            }
            addDynamicRoutes(router, menu.children, menu)
        } else {
            addDynamicRoutes(router, menu.children)
        }
    }
}

function toRoutes(menus) {
    let routes = []
    for (let menu of menus) {
        routes.push({
            path: menu.path,
            name: menu.menu_name,
            icon: menu.icon,
            icon_type: menu.icon_type,
            visible: menu.visible,
            component: importComponent(menu.component),
            children: toRoutes(menu.children),
        })
    }
    return routes
}

export function toSubjects(menus) {
    let subjects = []
    for (let menu of menus) {
        let routes = []
        if (menu.component) {
            routes = toRoutes([menu])
        } else {
            routes = toRoutes(menu.children)
        }
        subjects.push({
            path: menu.path,
            icon: menu.icon,
            icon_type: menu.icon_type,
            name: menu.menu_name,
            title: menu.menu_title,
            visible: menu.visible,
            routes: routes,
        })
    }
    return subjects
}
